import { put, takeLatest, delay } from "redux-saga/effects";
import { getLoyaltyPointDetailApi } from "store/api/SpecialOfferApi";
import { GET_LOYALTY_POINT_DETAIL_ACTION } from "../../actions/SpecialOfferPageAction/actionTypes";

import * as specialOfferPageAction from "../../actions/SpecialOfferPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getLoyaltyPointDetail(action) {
	yield put(globalAction.openLoadingPage());
	const { business, loyaltyId } = action.params;
	const res = yield getLoyaltyPointDetailApi(business, loyaltyId);

	try {
		if (res?.code === 0) {
			yield put(
				specialOfferPageAction.setLoyaltyPointDetailAction(res?.data)
			);
		} else {
			yield errorMessage(res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getLoyaltyPointDetailSaga() {
	yield takeLatest(GET_LOYALTY_POINT_DETAIL_ACTION, getLoyaltyPointDetail);
}

export default getLoyaltyPointDetailSaga;
